const Link = ({ clickMethod, children, href, className, text, target }) =>{
    return(
        <a href={href} className={className} target={target} onClick={clickMethod}>
            {text ? text : children}
        </a>
    )
}
export default Link